import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import find from "lodash/find"
import isEmpty from "lodash/isEmpty"
import { withRadium, DetectCompact } from "higher-order-components"
import { ServiceListInspect, ServiceListSelect } from "containers"
import { AccordionText } from 'AtomicContainers'
import { ServicingIcon, PlusIcon, CalculatorIcon } from "components"
import COLOR_PALETTE from "constants/color-palette"
import { actionCreators, selectors } from "store/actions/mymazda"
import ServiceMainPanel from "./panel"

class VehicleServiceDetails extends Component {
  constructor(props) {
    super(props)

    this.services = props.data.serviceItems
      .sort((s1, s2) => s1.factoryCodeEntity.distance - s2.factoryCodeEntity.distance)
      .slice(0, props.scheduledServiceItemsLimit > 0 ? props.scheduledServiceItemsLimit : 1e10)
      .map(s => {
        const m = /([^\s]+) Service or (.+)/.exec(s.factoryCodeEntity.description)
        return {
          name: m ? `${m[1]} Service | $${s.basePrice}` : s.factoryCodeEntity.description,
          extraLabel: m ? `or ${m[2]}` : "",
          price: `$${s.basePrice}`,
          basePrice: s.basePrice,
          shortName: m ? `${m[1]} Service` : s.factoryCodeEntity.description,
          code: s.factoryCodeEntity.code,
          item: s
        }
      })

    this.additionalServices = this.props.data.serviceItems
      .filter(s => s.factoryCodeEntity.type.match(/^Additional/))
      .map(s => ({
        name: s.factoryCodeEntity.description,
        description:
          s.operationActions.length > 0 ? s.operationActions[0].operations[0].description : "",
        price: `$${s.basePrice}`,
        basePrice: s.basePrice,
        code: s.factoryCodeEntity.code
      }))

    this.toggleService = code => {
      const newSelectedAdditionalServices = {
        ...this.props.service.selectedAdditionalServices
      }
      newSelectedAdditionalServices[code] = !newSelectedAdditionalServices[code]
      this.syncAdditionalServicesState(newSelectedAdditionalServices)
    }

    this.syncAdditionalServicesState = newSelectedAdditionalItems => {
      const { service, updateServiceDetails } = this.props

      if (isEmpty(newSelectedAdditionalItems)) {
        newSelectedAdditionalItems = service.selectedAdditionalServices
      } else {
        updateServiceDetails(
          {
            activeServiceCodeIndex: service.activeServiceCodeIndex,
            selectedAdditionalServices: newSelectedAdditionalItems
          },
          this.props.vin
        )
      }
    }

    this.findNonZeroDistance = () => {
      let distance = 0

      this.props.data &&
        this.props.data.serviceItems.forEach(item => {
          if (item.factoryCodeEntity.distance > 0 && distance === 0) {
            distance = item.factoryCodeEntity.distance
          }
        })

      return distance
    }
  }

  calculateTotal() {
    const { service } = this.props

    if (isEmpty(service) || isEmpty(service)) return "0"

    const activeService = this.services[service.activeServiceCodeIndex]
    const totalPrice = this.additionalServices
      .filter(s => service.selectedAdditionalServices[s.code])
      .reduce((price, s) => price + s.basePrice, activeService.basePrice)

    return `${totalPrice.toFixed(0)}`
  }

  getActiveService() {
    return this.services[this.props.service.activeServiceCodeIndex]
  }

  isSPG() {
    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      return this.props.data && this.props.data.serviceItems.some(si => si.factoryCode[0] === "M")
    } catch (e) {
      return false
    }
  }

  renderAdditionalDetails() {
    const {
      selectAdditionalItems: selectable, compact, service, expandDetails
    } = this.props
    const additionalItemsHeading = this.isSPG()
      ? "Optional Service Maintenance items"
      : "ADDITIONAL SCHEDULED MAINTENANCE"

    const totalPrice =
      service &&
      service &&
      this.additionalServices
        .filter(s => service.selectedAdditionalServices[s.code])
        .reduce((price, s) => price + s.basePrice, 0)
    return (
      <div style={styles.additionalServicesContainer}>
        {this.additionalServices &&
          !!this.additionalServices.length && (
            <div>
              <div
                style={{
                  borderBottom: compact && "1px solid #aaa",
                  marginBottom: compact && "1em"
                }}>
                <AccordionText
                  title={this.accordionTitle(additionalItemsHeading, "plus", totalPrice)}
                  styles={{ padding: compact ? "1.5em 3em 1.5em 0" : "1.5em 4em 1.5em 0" }}
                  name={"base"}
                  styleName='simple'
                  barBorder="top"
                  iconStyles={{ right: compact ? "0.5em" : "1em" }}
                  ignorePropsComponents
                  open={expandDetails}>
                  {selectable ? (
                    <div style={{paddingLeft: !compact && "3em"}}>
                      <div style={{ paddingTop: "1em" }}>
                        <p style={{ fontWeight: 200, textAlign: "left" }}>
                          Explore the items to better understand our service pricing. Items must be attended to when they are due but selections are not mandatory for booking a service.
                        </p>
                      </div>
                      <ServiceListSelect
                        services={this.additionalServices}
                        selectedServices={service && service.selectedAdditionalServices}
                        onServiceClick={code => this.toggleService(code)}
                        compact={compact} />
                      </div>
                  ) : (
                    <ServiceListInspect services={this.additionalServices} compact={compact} />
                  )}
                </AccordionText>
              </div>
            </div>
          )}
        {selectable && (
          <div style={{ width: "100%" }}>
            <div style={styles.totalServicePrice(compact)}>
              <div>
                {!compact && <CalculatorIcon style={styles.icon} />}
                Total service price
              </div>
              <div style={{ marginLeft: "2em" }}>
                <span style={styles.symbols(compact)}>$</span>
                <span style={styles.totalServicePriceValue(compact)}>{this.calculateTotal()}</span>
                <span style={styles.symbols(compact)}>*</span>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  accordionTitle(title, icon, price) {
    const { compact } = this.props

    return (
      <div style={styles.accordionTitle}>
        <span style={{ lineHeight: "20px", color: COLOR_PALETTE.BLACK }}>
          {!compact ? (
            icon === "servicing" ? (
              <ServicingIcon style={styles.icon} />
            ) : (
              <PlusIcon style={styles.icon} />
            )
          ) : null}
          {title}
        </span>
        <span style={{ textAlign: "center", minWidth: "60px", color: COLOR_PALETTE.BLACK }}>
          {price ? `$${price}` : <span style={styles.none}>None selected</span>}
        </span>
      </div>
    )
  }

  render() {
    const activeService = this.getActiveService()
    if (!activeService) return null

    const {
      data, factoryCode, expandDetails, compact
    } = this.props
    const spg = this.isSPG()
    const baseScheduleHeading = spg ? "Scheduled Maintenance" : "Base Scheduled Maintenance"
    const km = this.findNonZeroDistance()
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    const baseScheduleDescription = spg
      ? `Regular servicing is the key to maintaining your investment, which is why it’s important you return every ${km} kms. To ensure your car receives the best and most appropriate service schedule, you should consult your Mazda Dealer.`
      : `Base scheduled maintenance is due every ${km} km, but no longer than 12 months, whichever comes first.`

    const baseItem = find(data.serviceItems, { factoryCode })

    return (
      <div style={styles.base}>
        <AccordionText
          styleName='simple'
          title={this.accordionTitle(
            baseScheduleHeading,
            "servicing",
            baseItem && baseItem.basePrice
          )}
          styles={{ padding: compact ? "1.5em 3em 1.5em 0" : "1.5em 4em 1.5em 0" }}
          name={"base"}
          barBorder="top"
          iconStyles={{ right: compact ? "0.5em" : "1em" }}
          ignorePropsComponents
          open={expandDetails}>
          <div style={{paddingLeft: !compact && "3em"}}>
            {factoryCode && (
              <div
                style={{
                  paddingTop: "1em",
                  borderBottom: "1px solid rgb(203, 203, 203)",
                  width: "100%"
                }}>
                <p style={{ letterSpacing: ".2em", fontWeight: "600" }}>
                  {activeService.shortName} {activeService.extraLabel}
                </p>
                <p style={{ fontWeight: 200 }}>{baseScheduleDescription}</p>
              </div>
            )}
            <ServiceMainPanel
              services={this.services}
              activeService={activeService}
              factoryCode={this.props.factoryCode}
              activeServiceCodeIndex={this.state.activeServiceCodeIndex}
              compact={this.props.compact}
              onServiceSelect={index => {
                this.setState({ activeServiceCodeIndex: index })
              }} />
            </div>
        </AccordionText>
        {this.renderAdditionalDetails()}
      </div>
    )
  }
}

VehicleServiceDetails.propTypes = {
  data: PropTypes.object,
  factoryCode: PropTypes.string,
  selectAdditionalItems: PropTypes.bool,
  scheduledServiceItemsLimit: PropTypes.number,
  expandDetails: PropTypes.bool,
  compact: PropTypes.bool,
  service: PropTypes.object,
  vin: PropTypes.string,
  updateServiceDetails: PropTypes.func
}

VehicleServiceDetails.defaultProps = {
  data: {},
  factoryCode: "",
  serviceDetailsURL: "",
  selectAdditionalItems: false,
  compact: true
}

const mapStateToProps = (state, props) => ({
  service: selectors.getService(props.vin)(state)
})

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch)

export default withRadium(
  DetectCompact(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(VehicleServiceDetails)

const styles = {
  base: {
    width: "100%"
  },

  mainServiceHeader: {
    textAlign: "left",
    lineHeight: 1.2,
    width: "100%"
  },

  icon: {
    verticalAlign: "bottom",
    marginRight: "1.75em",
    width: "1.25em",
    height: "1.25em",
    fill: COLOR_PALETTE.GRAY_DARK
  },

  introOwner: compact => ({
    display: "flex",
    flexDirection: compact ? "column" : "row",
    alignItems: "baseline",
    padding: "0.4em 0 1em",
    justifyContent: "space-between"
  }),

  accordionTitle: {
    letterSpacing: ".2em",
    fontWeight: "600",
    padding: "1em 0",
    borderTop: "1px solid " + COLOR_PALETTE.GRAY_LIGHT,
    textAlign: "left",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },

  none: {
    fontSize: "12px",
    fontWeight: "200",
    letterSpacing: "initial",
    textTransform: "none",
    display: "block",
    marginTop: "-3px",
    width: "5em",
    textAlign: "center",
    lineHeight: "11px",
    color: COLOR_PALETTE.GRAY_DARK
  },

  additionalServicesContainer: {
    boxSizing: "border-box",
    width: "100%",
    display: "block",
    padding: 0
  },

  totalServicePrice: compact => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    textTransform: "uppercase",
    fontWeight: 600,
    borderTop: !compact && "1px solid #d5d5d5",
    letterSpacing: "0.2em",
    padding: "1.5em 0 1.5em 0",
    alignItems: "center"
  }),

  totalServicePriceValue: compact => ({
    paddingBottom: "0.2em",
    fontSize: compact ? "140%" : "160%",
    fontWeight: compact && "600",
    letterSpacing: "2px"
  }),

  symbols: compact => ({
    verticalAlign: "top",
    paddingTop: ".1em",
    letterSpacing: compact && "0",
    fontWeight: compact && "600",
    fontSize: compact && "140%"
  })
}



// WEBPACK FOOTER //
// ./src/components/mymazda/service/details.jsx